import {
    PARCELAS_LOCAL_CATALOG_SOURCE,
    PARCELAS_SIEX_CATALOG_SOURCE,
    type ParcelasDropdownDataSourceFactory,
    type SourceAwareParcelasCatalogRow
} from './parcelas-dropdown-datasource.factory';

export type ParcelasCatalogSerializerContext = {
    readonly dataSourceFactory: ParcelasDropdownDataSourceFactory;
    readonly value: unknown;
    readonly selectedRow: SourceAwareParcelasCatalogRow | null;
};

/**
 * Converts source-aware Parcelas catalog values back to the legacy backend payload expected by parcelas endpoints.
 *
 * The visual component resolves the current dropdown raw value, while this adapter owns source-specific precedence
 * rules. Keeping these rules here makes SIEX/local catalog compatibility testable outside Angular lifecycle code.
 */
export class ParcelasCatalogSerializerAdapter {

    public static toLegacyCultivoPayloadValue(context: ParcelasCatalogSerializerContext): unknown {
        const parsedValue = context.dataSourceFactory.parseCatalogKey(context.value);
        const selectedCultivo = context.selectedRow;

        if (selectedCultivo?.source === PARCELAS_LOCAL_CATALOG_SOURCE) {
            return context.dataSourceFactory.resolveFirstCatalogValue(
                selectedCultivo.id,
                selectedCultivo.codigo,
                selectedCultivo.codigo_cultivo,
                parsedValue.primaryCode,
                context.value,
            );
        }

        return context.dataSourceFactory.resolveFirstCatalogValue(
            selectedCultivo?.codigo,
            selectedCultivo?.codigo_cultivo,
            parsedValue.primaryCode,
            selectedCultivo?.id,
            context.value,
        );
    }

    public static toLegacyVariedadPayloadValue(context: ParcelasCatalogSerializerContext): unknown {
        const parsedValue = context.dataSourceFactory.parseCatalogKey(context.value);
        const selectedVariedad = context.selectedRow;

        if (selectedVariedad?.source === PARCELAS_SIEX_CATALOG_SOURCE) {
            return context.dataSourceFactory.resolveFirstCatalogValue(
                selectedVariedad.codigo_variedad,
                selectedVariedad.id_variedad,
                parsedValue.secondaryCode,
                selectedVariedad.id,
                context.value,
            );
        }

        return context.dataSourceFactory.resolveFirstCatalogValue(
            selectedVariedad?.id,
            selectedVariedad?.id_variedad,
            selectedVariedad?.codigo_variedad,
            parsedValue.secondaryCode,
            context.value,
        );
    }
}
